/**
 * 全局主题混入 (Mixin)
 * 为页面组件提供便捷的主题访问和切换功能
 */
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        // 映射主题相关的getters
        ...mapGetters('theme', [
            'currentThemeConfig',
            'themeButtonStyle', 
            'themeIconColor',
            'themePageBackground',
            'themeCardBackground',
            'availableThemes'
        ]),
        
        // 获取当前主题名称
        currentTheme() {
            return this.$store.state.theme.currentTheme;
        },
        
        // 获取主题配置对象
        themeConfig() {
            return this.$store.state.theme.themeConfig;
        }
    },
    
    methods: {
        // 映射主题相关的actions
        ...mapActions('theme', [
            'switchTheme',
            'switchToNextTheme', 
            'initTheme',
            'customizeTheme'
        ]),
        
        // 便捷的主题切换方法
        handleThemeSwitch(themeName) {
            return this.switchTheme(themeName).then((config) => {
                // 主题切换成功回调
                this.onThemeChanged && this.onThemeChanged(themeName, config);
                return config;
            }).catch((error) => {
                // 主题切换失败回调
                console.error('主题切换失败:', error);
                this.onThemeChangeError && this.onThemeChangeError(error);
                return Promise.reject(error);
            });
        },
        
        // 获取特定元素的主题样式
        getThemeStyle(elementType, customStyle = {}) {
            const baseStyle = (() => {
                switch (elementType) {
                    case 'button':
                        return this.themeButtonStyle;
                    case 'page':
                        return this.themePageBackground;
                    case 'card':
                        return this.themeCardBackground;
                    case 'icon':
                        return { color: this.themeIconColor };
                    case 'text':
                        return { color: this.currentThemeConfig.textColor };
                    default:
                        return {};
                }
            })();
            
            return { ...baseStyle, ...customStyle };
        },
        
        // 检查主题是否存在
        isValidTheme(themeName) {
            return !!this.themeConfig[themeName];
        }
    },
    
    // 生命周期钩子 - 在组件创建时初始化主题
    created() {
        // 确保主题已初始化
        this.initTheme();
    },
    
    // 监听主题变化
    watch: {
        currentTheme: {
            handler(newTheme, oldTheme) {
                // 当主题发生变化时，触发组件的主题更新回调
                if (this.onThemeUpdate && typeof this.onThemeUpdate === 'function') {
                    this.onThemeUpdate(newTheme, oldTheme, this.currentThemeConfig);
                }
            },
            immediate: false
        }
    }
};
